import { CONTACT_INFO } from '../data/resumeData';
import { FaLink, FaLinkedin, FaGithubSquare } from 'react-icons/fa';
import { ImMail2, ImPhone } from 'react-icons/im';

export default function ContactInfo() {
    return (
        <section id="ContactInfo">
            <ul>
                <li><ImPhone title="Phone" />{CONTACT_INFO.phone}</li>
                <li><ImMail2 title="Email" />{CONTACT_INFO.email}</li>
                <li>
                    <a href={CONTACT_INFO.linkedIn.url}><FaLinkedin title="LinkedIn" /></a> 
                    <a href={CONTACT_INFO.linkedIn.url}>{CONTACT_INFO.linkedIn.text}</a>
                </li>
                <li>
                    <a href={CONTACT_INFO.gitHub.url}><FaGithubSquare title="GitHub" /></a>
                    <a href={CONTACT_INFO.gitHub.url}>{CONTACT_INFO.gitHub.text}</a>
                </li>
                <li>
                    <a href={CONTACT_INFO.siteName.url}><FaLink title="Donchano" /></a>
                    <a href={CONTACT_INFO.siteName.url}>{CONTACT_INFO.siteName.text}</a>
                </li>
            </ul>
        </section>
    )
}